document.addEventListener('click', async event => {
  const preferences = event.target.closest('[data-dh-cookie-preferences]');
  if (preferences) {
    event.preventDefault();
    const banner = window.privacyBanner || window.Shopify?.privacyBanner;
    if (banner?.showPreferences) {
      await banner.showPreferences();
    } else {
      let status = document.querySelector('[data-dh-cookie-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.dhCookieStatus = '';
        status.setAttribute('role', 'status');
        preferences.after(status);
      }
      status.textContent = 'Las preferencias no están disponibles en esta vista. Inténtalo desde la tienda online.';
    }
  }
  if (event.target.closest('[data-dh-print-withdrawal]')) {
    const form = document.querySelector('#formulario-desistimiento');
    if (!form) return;
    const printWindow = window.open('', '_blank', 'width=800,height=900');
    if (!printWindow) return;
    const doc = printWindow.document;
    doc.title = 'Formulario de desistimiento';
    doc.documentElement.lang = 'es';
    const style = doc.createElement('style');
    style.textContent = 'body{font-family:Arial,sans-serif;color:#111;margin:40px;line-height:1.5}h2{font-size:22px}p{margin:0 0 16px}';
    doc.head.appendChild(style);
    doc.body.appendChild(form.cloneNode(true));
    printWindow.focus();
    printWindow.print();
  }
});